/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import AddToCart from '../../../../Components/AddtoCartModal';
import CategoryToolTip from '../../../../Components/CategoryToolTip';
import EmptyPage from '../../../../Components/EmptyPage';
import ProductComponent from './ProductComponent';
import FilterSection from './FilterSection';
import ResposiveFilterModal from './ResposiveFilterModal';

const sortValues = [{
    id: 2,
    name: 'Expected Dispatch Date',
    label: 'Dispatch Date',
    value: 'EXPECTED_DELIVERY_DATE asc',
},
{
    id: 3,
    name: 'MOQ: Low to high',
    label: 'MOQ: Low to high',
    value: 'MINIMUM_ORDER_QUANTITY asc',
},
{
    id: 4,
    name: 'MOQ: High to low',
    label: 'MOQ: High to low',
    value: 'MINIMUM_ORDER_QUANTITY desc',
},
{
    id: 5,
    name: 'List Price: Low to high',
    label: 'List Price: Low to high',
    value: 'LIST_PRICE asc',
},
{
    id: 6,
    name: 'List Price: High to low',
    label: 'List Price: High to low',
    value: 'LIST_PRICE desc',
}];
export default function ProductList({
    Products,
    payload,
    handleToggle,
    toggles,
    handlePayload,
    setpriceRange,
    priceRange,
    handleApply,
    Filters,
    Segments,
    setSegments,
    Size,
    setSize,
    handleIsExist,
    handleSelect,
    handleCheckBox,
    handleClear,
    uniqCount,
    STOCK_VISIBILITY,
    resposivePopup,
    setresposivePopup,
    checkBox,
    wishlistProduct,
    result,
    GetCartItems,
    Cart,
    handlefetch,
    OrderDetails,
    sizeList,
    lengthList,
    defaultAddress,
    clearLoader,
    setClearLoader,
}) {
    const handleSortName = () => sortValues.filter((val) => val.value === payload.sort);
    const [selectedItem, setselectedItem] = useState({});
    const [show, setShow] = useState('');
    const [CartId, setCartId] = useState({});

    return (
        <motion.div
            initial={{ opacity: 0, scale: 1 }}
            animate={{ opacity: 1, scale: 1 }}
            className="flex"
        >
            <FilterSection
                handlePayload={handlePayload}
                uniqCount={uniqCount}
                payload={payload}
                setpriceRange={setpriceRange}
                handleApply={handleApply}
                Filters={Filters}
                priceRange={priceRange}
                Segments={Segments}
                setSegments={setSegments}
                handleIsExist={handleIsExist}
                handleSelect={handleSelect}
                setSize={setSize}
                Size={Size}
                handleCheckBox={handleCheckBox}
                checkBox={checkBox}
                result={result}
                handleClear={handleClear}
                sizeList={sizeList}
                lengthList={lengthList}
                clearLoader={clearLoader}
                setClearLoader={setClearLoader}
            />
            <div className="xl:w-[80%] lg:px-[18px] md:px-[46px] px-4 pb-10 overflow-auto h-[800px]" style={{ height: `${Products?.length > 3 ? '' : '80vh'}` }}>
                <div className="w-full">
                    <div className="flex sm:justify-end justify-between items-center sticky top-0 bg-white z-[99]">
                        {/* <!-- sort dropdown --> */}
                        <div className=" w-1/4 inline-block pr-2 pt-0">
                            <input type="text" onChange={(e) => handlePayload('search', e.target.value)} name="search" id="search" className="w-full h-9 bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]" placeholder="Search" autoComplete="off" />
                        </div>
                        <div className="bg-[#F5F5FA] rounded-md py-2 w-fit px-4 flex items-center pt-[18px]">
                            <span className="text-xs font-bold text-[#808285]">Sort by:</span>
                            <div className="dropdown relative cursor-pointer">
                                <button type="button" onClick={() => handleToggle('sort')} id="spacial1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-sort flex items-center">
                                    <p className="text-sm font-semibold text-[#555259] px-1.5">{payload.sort && handleSortName()[0].label}</p>
                                    <img src="/images/dropdown-filled.svg" alt="icon" />
                                </button>
                                <ul className={`dropdown-sort-content sm:w-[250px] w-[201px] absolute top-7 right-0 bg-[#FFFFFF] rounded-[10px] shadow-s2 z-[9999] sm:pl-6 pl-2 pr-1 py-3 ${toggles.sort ? '' : 'hidden'}`} aria-labelledby="special1">
                                    {sortValues.map((item, i) => (
                                        <li className={`w-full bg-[#ffffff] ${i === 0 ? '' : 'pt-1.5'}`} key={item.id}>
                                            <div className="w-full flex items-center">
                                                <div className="relative checkbox custom-checkbox custom-radio flex items-center">
                                                    <input
                                                        type="radio"
                                                        onChange={() => handlePayload('sort', item.value)}
                                                        id={`checkbox-91${item.id}`}
                                                        checked={item.value === payload.sort}
                                                        name="radiodate"
                                                        className="cursor-pointer"
                                                    />
                                                    <label htmlFor={`checkbox-91${item.id}`} className="sm:text-base text-sm font-semibold text-[#555259] pl-2 cursor-pointer">{item.name}</label>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* <!-- product list and info section --> */}
                    {Products?.length > 0 ? (
                        <>
                            {Products.map((prod, i) => (
                                <div className="pt-[18px]" key={`${prod.INVENTORY_ITEM_ID}-${i}-${prod.DESCRIPTION}`}>
                                    <ProductComponent
                                        prod={prod}
                                        type="productlist"
                                        setselectedItem={setselectedItem}
                                        setshow={setShow}
                                        wishlistProduct={wishlistProduct}
                                        STOCK_VISIBILITY={STOCK_VISIBILITY}
                                        setCartId={setCartId}
                                        CartId={CartId}
                                        Cart={Cart}
                                        OrderDetails={OrderDetails}
                                    />
                                </div>
                            ))}
                        </>
                    ) : <EmptyPage tag="no products" STOCK_VISIBILITY={STOCK_VISIBILITY} />}
                </div>
            </div>
            <AddToCart product={CartId} isClose={setCartId} handlefetch={handlefetch} Cart={Cart} OrderDetails={OrderDetails} defaultAddress={defaultAddress} />
        </motion.div>
    );
}
